import { createContext } from "react";
const PromoCodeContext = createContext({});

export default PromoCodeContext;
